var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isServer)?_c('div',[_c('p',[_vm._v("Clearing Cache...")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.window.location = _vm.window.location.origin}}},[_vm._v("Continue")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }